import React, { FC, useEffect, useState } from 'react';

import FullscreenPreloader from '~/components/atoms/FullscreenPreloader';
import analytics from '~/services/analytics';
import localStorage from '~/services/storage/localStorage';
import sessionStorage from '~/services/storage/sessionStorage';
import { useActions } from '~/store/hooks/useActions';

const AUTO_LOGIN_COMPLETE_KEY = 'auto-login-complete';
const ACCESS_TOKEN_KEY = 'access_token';

type Props = {
  children?: React.ReactNode;
};

const CheckAuthWrapper: FC<Props> = ({ children }) => {
  const { checkIsUserLoggedIn } = useActions();
  const [isLoading, setIsLoading] = useState(true);

  const load = async (): Promise<void> => {
    try {
      setIsLoading(true);

      // Skip auth check if no tokens exist — allows anonymous access
      const hasTokens = !!localStorage.getByKey(ACCESS_TOKEN_KEY);
      if (!hasTokens) {
        return;
      }

      await checkIsUserLoggedIn();
      if (
        document.referrer &&
        !sessionStorage.getByKey(AUTO_LOGIN_COMPLETE_KEY)
      ) {
        const refererHost = new URL(document.referrer).host;
        if (
          refererHost !== document.location.host &&
          (refererHost.includes('justdone') ||
            refererHost.includes('sidekicker'))
        ) {
          sessionStorage.setByKey(AUTO_LOGIN_COMPLETE_KEY, '1');
          analytics.trackEvent('login - auto authorization from landing');
        }
      }
      analytics.trackEvent('login - load private page');
    } catch (e: any) {
      console.error('CheckAuthWrapper', e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return isLoading ? <FullscreenPreloader /> : <>{children}</>;
};
export { CheckAuthWrapper };
